import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import NewsPage from "@/pages/news/page";
import WorksPage from "@/pages/works/page";
import DetailPage from "@/pages/detail/page";
import FansPage from "@/pages/fans/page";
import AboutPage from "@/pages/about/page";
import ContactPage from "@/pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "news",
        element: <NewsPage />,
      },
      {
        path: "works",
        element: <WorksPage />,
      },
      {
        path: "detail/:id",
        element: <DetailPage />,
      },
      {
        path: "fans",
        element: <FansPage />,
      },
      {
        path: "about",
        element: <AboutPage />,
      },
      {
        path: "contact",
        element: <ContactPage />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;